<template>
    <v-dialog
        v-model="dialog"
        persistent
        width="750"
        content-class="elevation-0 pa-16 border-radius-3"
        hide-overlay
    >
        <v-card class="border-radius-3 px-16 py-7 position-relative" color="white">
            <div class="position-absolute bees bee-1" v-if="stepIndex === 0 || stepIndex === 2">
                <img :src="bee_1" class="bee" />
            </div>
            <div class="position-absolute bees bee-2" v-if="stepIndex === 0 || stepIndex === 2">
                <img :src="bee_5" class="bee" />
            </div>
            <div class="position-absolute bees bee-3" v-if="stepIndex === 1">
                <img :src="bee_3" class="bee" />
            </div>
            <div class="position-absolute bees bee-4" v-if="stepIndex === 3">
                <img :src="bee_2" class="bee" />
            </div>
            <div class="position-absolute bees bee-5" v-if="stepIndex === 3">
                <img :src="bee_5" class="bee" />
            </div>
            <div class="d-flex justify-start badges-corner dialog-corner">
                <CornerBadge data-cy="corner-badge-number">
                    <span class="corner-number">{{ stepIndex + 1 }}</span>
                </CornerBadge>
            </div>
            <v-row class="d-flex justify-start mb-5 position-relative mt-5">
                <v-card-title class="px-5  mx-10"
                    ><span
                        class="titles font-size-28 text-left font-weight-regular primary--text break-line-space"
                        v-html="$t('initialTour.tutorialTitle')"
                    ></span
                ></v-card-title>
                <v-card-text class="px-5 text-left  mx-10"
                    ><span
                        class="primary--text text-h6 text-left"
                        v-html="this.steps[stepIndex]"
                    ></span
                ></v-card-text>
            </v-row>
            <v-card-actions class="d-flex justify-start px-5 mx-5 break-line-space">
                <x-ArrowButtonOutline data-cy="back-button-tutorial-diagnostic" class="mr-5" v-if="stepIndex > 0" v-on:brClick="prevPass"
                    ><span class="secondary--text">{{
                        $t('initialTour.return')
                    }}</span></x-ArrowButtonOutline
                >
                <x-ArrowButton v-on:brClick="nextPass" data-cy="continue-button-tutorial-diagnostic"
                    ><span class="white--text">{{
                        $t('initialTour.continue')
                    }}</span></x-ArrowButton
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
/* eslint-disable global-require */

import { mapState, mapActions } from 'vuex'

import CornerBadge from './DiagnosticCore/CornerBadge.vue'

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    components: {
        CornerBadge,
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
            survey: (state) => state.userData.survey,
            diagnosticData: (state) => state.dashboard.testDiagnostic,
        }),
        finish_message() {
            // eslint-disable-next-line no-nested-ternary
            // return `${this.$t('initialTour.previus_diagnostic_msg',{'userName'})} ${this.user.firstname.split(' ')[0]}!`
            const username = this.user.firstname.split(' ')[0]
            return `${this.$t('initialTour.previus_diagnostic_msg', { username })}`
        },
    },
    mounted() {
        const count = this.diagnosticData.length
        const countQuestions = this.diagnosticData.reduce( (a, diagnostic) => { return a + diagnostic.diagnostic.questions.length }, 0);
        this.steps.push(this.$t('initialTour.steps_msgs.msg_1', { count, countQuestions }))
        this.steps.push(this.$t('initialTour.steps_msgs.msg_2'))
        this.steps.push(this.$t('initialTour.steps_msgs.msg_3'))
        this.steps.push(this.$t('initialTour.steps_msgs.msg_4'))
    },
    data() {
        return {
            steps: [],
            stepIndex: 0,
            bee_1: require('@/assets/img/bees/bee001.svg'),
            bee_2: require('@/assets/img/bees/bee002.svg'),
            bee_3: require('@/assets/img/bees/bee003.svg'),
            bee_4: require('@/assets/img/bees/bee004.svg'),
            bee_5: require('@/assets/img/bees/bee005.svg'),
        }
    },
    methods: {
        ...mapActions('dashboard', ['showDiagnosticTutorialModal', 'mountDiagnostic']),
        nextPass() {
            if (this.stepIndex < this.steps.length - 1) this.stepIndex += 1
            else {
                this.showDiagnosticTutorialModal()
                this.mountDiagnostic()
            }
        },
        prevPass() {
            if (this.stepIndex !== 0) this.stepIndex -= 1
        },
    },
}
</script>
<style>
.break-line-space {
    white-space: nowrap;
}

.dialog-corner {
    position: absolute;
    z-index: 99990;
    left: -2vh;
    top: -2vh;
}

.corner-number {
    font-family: 'Patua One', cursive !important;
    font-weight: 500;
    font-size: 48px;
    font-weight: 500;
    color: #ff7a22;
}

.continue-btn::after {
    content: '';
    position: absolute;
    left: 98%;
    /* top: 100%; */
    width: 0;
    height: 0;
    clear: both;
    border-left: 5vh solid #ff6f3a;
    border-right: 5vh solid transparent;
    border-top: 3.5vh solid transparent;
    border-bottom: 3.5vh solid transparent;
    box-shadow: 0 0px 0px 0px, 0 0px 0px 0, 0 0px 0px 0 rgba(0, 0, 0, 0.12) !important;
}

/* BEES */
.bees {
    z-index: 100;
    width: 15vh;
}
.bee-1 {
    right: -2vh;
    bottom: -3vh;
}
.bee-2 {
    right: 50%;
    top: -8vh;
}
.bee-3 {
    top: 33.33%;
    right: -5vh;
}
.bee-4 {
    left: 35%;
    top: -8vh;
}
.bee-5 {
    bottom: 0vh;
    right: 4vh;
}
.bee {
    width: 15vh;
}
</style>
